import {parseDecimal} from '../../../../utils/index.js';
import {rendasDoMembro} from '../../../publica/Page/inscricao/rendaMembro.js';

/*
 * Cálculo da aba Socioeconômico do administrativo, o mesmo do
 * RendaFamiliarBean do back:
 * - renda familiar bruta = rendas dos integrantes + rendas do próprio inscrito;
 * - renda bruta total = pensões (alimentícia e dos filhos) + renda familiar bruta;
 * - per capita = renda bruta total / (integrantes + 1), com 2 casas e HALF_UP.
 * As contas são feitas em centavos inteiros para não acumular erro de ponto flutuante.
 */

const paraCentavos = valor => {
    const numero = parseDecimal(valor);
    return numero === null || !Number.isFinite(numero) ? 0 : Math.round(numero * 100);
};

const somarCentavos = valores => valores.reduce((total, valor) => total + valor, 0);

/* Divisão inteira com arredondamento HALF_UP (metade sempre se afasta do zero), como o BigDecimal. */
export const dividirHalfUp = (dividendo, divisor) => {
    if (!divisor) return 0;
    const sinal = Math.sign(dividendo) * Math.sign(divisor) < 0 ? -1 : 1;
    const a = Math.abs(dividendo);
    const b = Math.abs(divisor);
    const quociente = Math.floor(a / b);
    const resto = a - quociente * b;
    return sinal * (resto * 2 >= b ? quociente + 1 : quociente);
};

/* Renda bruta do integrante: soma das ocupações/rendas dele (ou o rendaBruta legado, quando não há a lista). */
export const centavosDoMembro = membro => somarCentavos(rendasDoMembro(membro).map(renda => paraCentavos(renda?.vlrRenda)));

export const calcularRendaInscricao = ({renda = [], composicaoFamiliar = [], vlrPensao, vlrPensaoFilho} = {}) => {
    const membros = composicaoFamiliar || [];
    const centavosMembros = somarCentavos(membros.map(centavosDoMembro));
    const centavosProprios = somarCentavos((renda || []).map(item => paraCentavos(item?.vlrRenda)));
    const centavosFamiliar = centavosMembros + centavosProprios;
    const centavosTotal = paraCentavos(vlrPensao) + paraCentavos(vlrPensaoFilho) + centavosFamiliar;

    return {
        rendaFamiliarBruta: centavosFamiliar / 100,
        rendaBrutaTotal: centavosTotal / 100,
        rendaPerCapita: dividirHalfUp(centavosTotal, membros.length + 1) / 100
    };
};
